<script lang="ts">
import { defineComponent} from 'vue'

export default defineComponent({
  name: "SchemataOverlay",
  setup(props) {
    const schemata = props.schemata;
    
    return {schemata}
  },
  props: {
    schemata: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onSave() {
      this.$emit('schemata-save');
    },
    onCancel() {
      this.$emit('schemata-back', false);
    },
    updateArray() {
      this.schemata.schemata = this.schemata.schemata.filter(entry => typeof entry === 'number')
    },
  }
})
</script>

<template>
  <v-container class="container py-6 d-flex align-center justify-center bg-white flex-column">
    <h3 class="mb-8">Schemata Eingabe</h3>
    <v-row>
      <v-col>
        <v-text-field @change="updateArray" type="number" v-model.number="schemata.schemata[0]" ></v-text-field>
      </v-col>
      <v-col>
        <h1>+</h1>
      </v-col>
      <v-col>
        <v-text-field @change="updateArray" type="number" v-model.number="schemata.schemata[1]"></v-text-field>
      </v-col>
      <v-col>
        <h1>+</h1>
      </v-col>
      <v-col>
        <v-text-field @change="updateArray" type="number" v-model.number="schemata.schemata[2]" ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn @click="onCancel">Zurück</v-btn>
      </v-col>
    </v-row>
  </v-container>  
</template>

<style scoped>
.container {
  border-radius: 5px;
  background: white;
}
</style>